import React from 'react'
import { motion } from "motion/react"
import SkillDetail from '../SkillDetail'
import { variants, useRevealInitial } from "../../lib/motion"

const SkillsCustomCard = ({ skills }) => {
  return (
    <section className="mx-auto max-w-3xl border-t border-ink-800 px-6 py-12" id="skills">
      <h2 className="mb-4 text-2xl font-semibold text-mist-100">Skills Used</h2>
      <motion.div
        className="flex flex-wrap gap-3"
        initial={useRevealInitial("hidden")}
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        variants={variants.staggerContainer}
      >
        {skills.map((skill, skillIndex) => (
          <motion.div key={skillIndex} variants={variants.fadeUp}>
            <SkillDetail imgsrc={skill.imgsrc} alt={skill.text} text={skill.text} />
          </motion.div>
        ))}
      </motion.div>
    </section>
  )
}

export default SkillsCustomCard
